// Rates are WebSocket payload bytes, including the Live protocol header.
// Transport/TLS overhead and HTTP assets are outside these counters.
export class NetworkHistory {
    constructor(capacity = 120) { this.incoming = new Float32Array(capacity); this.outgoing = new Float32Array(capacity); this.reset(); }
    reset() { this.previous = null; this.count = this.cursor = 0; this.incoming.fill(0); this.outgoing.fill(0); }
    push(report) {
        if (!Number.isFinite(report?.measuredAt) || report.measuredAt === this.previous?.measuredAt) return;
        const old = this.previous; this.previous = report;
        if (!old || report.measuredAt <= old.measuredAt || report.bytesReceived < old.bytesReceived || report.bytesSent < old.bytesSent) return;
        const seconds = (report.measuredAt - old.measuredAt) / 1000;
        this.incoming[this.cursor] = (report.bytesReceived - old.bytesReceived) / seconds;
        this.outgoing[this.cursor] = (report.bytesSent - old.bytesSent) / seconds;
        this.cursor = (this.cursor + 1) % this.incoming.length; this.count = Math.min(this.count + 1, this.incoming.length);
    }
    latest() { const i = (this.cursor + this.incoming.length - 1) % this.incoming.length; return [this.incoming[i], this.outgoing[i]]; }
}
